export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const ADAS_SEARCH_TERM = 'ADAS_SEARCH_TERM'
export const ADAS_PAGE_SIZE = 'ADAS_PAGE_SIZE'
export const ADAS_SORT_DIR = 'ADAS_SORT_DIR'
export const ADAS_ORDER_BY = 'ADAS_ORDER_BY'
export const ADAS_FILTER_BY = 'ADAS_FILTER_BY'
export const INIT_ADAS = 'INIT_ADAS'
export const INIT_ADASINSPECTION = 'INIT_ADASINSPECTION'
export const SET_ADAS = 'SET_ADAS'
export const SET_ADASS = 'SET_ADASS'
export const UPDATE_ADAS = 'UPDATE_ADAS'
export const SET_ADASINSPECTIONS = 'SET_ADASINSPECTIONS'
export const SET_ADASINSPECTION = 'SET_ADASINSPECTION'
export const UPDATE_ADASINSPECTION = 'UPDATE_ADASINSPECTION'
export const SET_ADASINSPECTIONRESULTS = 'SET_ADASINSPECTIONRESULTS'
export const SET_REPORTPREFERENCE = 'SET_REPORTPREFERENCE'
export const SET_ADASINSPECTIONITEMS = 'SET_ADASINSPECTIONITEMS'
export const SET_ADAS_STATUS = 'SET_ADAS_STATUS'
export const SET_ADAS_INSPECTION_STATUS = 'SET_ADAS_INSPECTION_STATUS'
export const UPDATE_ADAS_INSPECTION_RECORD = 'UPDATE_ADAS_INSPECTION_RECORD'
export const SET_ADAS_RESET = 'SET_ADAS_RESET'
export const SET_LINKS = 'SET_LINKS'
export const SET_DECODED = 'SET_DECODED'
export const SET_REPAIRLINES = 'SET_REPAIRLINES'
export const SET_EQUIPPED = 'SET_EQUIPPED'
export const SET_RESULT_EQUIPPED = 'SET_RESULT_EQUIPPED'
export const RESET_REQUEST = 'RESET_REQUEST'
export const RESET_REQUESTS = 'RESET_REQUESTS'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_REQUEST = 'SET_REQUEST'
export const SET_REQUEST_NOTES = 'SET_REQUEST_NOTES'
export const SET_ADASINSPECTION_NOT_INSTALLED = 'SET_ADASINSPECTION_NOT_INSTALLED'


// WEBPACK FOOTER //
// ./src/store/modules/adas/types.js